<div class="container">
  <div class="alphalearn-logo">
    <img
      src="assets/images/Logo_Alphalearn_outlines_fluid_animated.svg"
      alt="AlphaLearn"
    />
  </div>
  <div class="header-spacer"></div>
  <!-- Agent, notifications and the user stay together top right, one size (scss: .header-actions). -->
  <div class="header-actions">
  <button
    *ngIf="agentChat.enabled()"
    nbButton
    ghost
    size="small"
    type="button"
    class="agent-button"
    (click)="agentChat.toggle()"
    [class.agent-button--open]="agentChat.open()"
    [attr.aria-pressed]="agentChat.open()"
    [attr.aria-label]="'agentPanel.open' | translate"
    [nbTooltip]="'agentPanel.open' | translate"
  >
    <nb-icon icon="orbi" pack="al"></nb-icon>
    <!-- changes the person's own agent (MCP) proposed and that wait for them -->
    <span *ngIf="agentApprovals.openCount() as count" class="agent-button__badge">{{ count }}</span>
  </button>
  <div class="notification-area" *ngIf="showNotificationBell">
    <button
      nbButton
      ghost
      size="small"
      (click)="toggleNotifications()"
      class="notification-bell"
    >
      <nb-icon icon="bell-outline"></nb-icon>
      <span *ngIf="unreadNotifications > 0" class="notification-badge">
        {{ unreadNotifications > 99 ? '99+' : unreadNotifications }}
      </span>
    </button>

    <div class="notification-popover" *ngIf="notificationsOpen">
      <div class="notification-popover-header">
        <span>{{ "components.notifications.title" | translate }}</span>
        <button
          nbButton
          ghost
          size="tiny"
          *ngIf="(notificationService.notifications$ | async)?.length"
          (click)="onMarkAllRead(); $event.stopPropagation()"
        >
          {{ "components.notifications.markAllRead" | translate }}
        </button>
      </div>
      <div class="notification-popover-list">
        <ng-container
          *ngIf="(notificationService.notifications$ | async) as notifications"
        >
          <div
            *ngFor="let n of notifications"
            class="notification-item"
            [attr.data-notification-type]="n.type"
            [class.unread]="!n.is_read"
            (click)="onNotificationClick(n)"
          >
            <div class="notification-title">
              {{ getNotificationTitle(n) }}
            </div>
            <div class="notification-body" *ngIf="getNotificationBody(n) as body">
              {{ body }}
            </div>
            <div class="notification-time">
              {{ n.created_at | date: "dd.MM.yy HH:mm" }}
            </div>
          </div>
          <div *ngIf="!notifications.length" class="notification-empty">
            {{ "components.notifications.empty" | translate }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="user" *ngIf="userMenu.length > 0">
    <nb-user
      [nbContextMenu]="userMenu"
      nbContextMenuTag="userMenuTag"
      [onlyPicture]="userPictureOnly"
      [name]="name"
      [picture]="userService.getAvatar((userService.me$ | async)?.email || '')"
    >
    </nb-user>
  </div>
  </div>
</div>
